import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot, $createTextNode, TextNode } from 'lexical';
import { $createMentionNode } from './MentionNode';

// Regex to match mention tags like [PATENT_12345], [UPLOAD_filename], etc.
const MENTION_REGEX = /\[(PATENT|PUBLICATION|APPLICATION|FOREIGN_PATENT|UPLOAD|MPEP|CFR|USC|DRAFT|PROS_DOC)_([^\]]+)\]/;

function findAndTransformTags(node: TextNode): void {
  const text = node.getTextContent();
  const match = text.match(MENTION_REGEX);

  if (match && match.index !== undefined) {
    const matchIndex = match.index;
    const matchLength = match[0].length;
    const docType = match[1];
    const docId = match[2];

    const beforeText = text.substring(0, matchIndex);
    const afterText = text.substring(matchIndex + matchLength);

    // Create mention node
    const mentionNode = $createMentionNode(
      `${docType} ${docId}`,
      docId,
      docType
    );

    if (beforeText) {
      const beforeNode = $createTextNode(beforeText);
      node.insertBefore(beforeNode);
      // Check if beforeNode has more tags
      findAndTransformTags(beforeNode as TextNode);
    }

    node.replace(mentionNode);

    if (afterText) {
      const afterNode = $createTextNode(afterText);
      mentionNode.insertAfter(afterNode);
      // Check if afterNode has more tags
      findAndTransformTags(afterNode as TextNode);
    }
  }
}

export function TagsToMentionsPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerNodeTransform(TextNode, (textNode) => {
      findAndTransformTags(textNode);
    });
  }, [editor]);

  return null;
}
